export default {
    "recurring_plan_daily":'{num, plural, one {day} other {{num} days}}',
    "recurring_plan_weekly":'{num, plural, one {week} other {{num} weeks}}',
    "recurring_plan_monthly":'{num, plural, one {mo} other {{num} mo}}',
    "recurring_plan_yearly":'year',
    "due_in_x":'Due in {x, number} {x, plural, one {day} other {days}}',
    "x members":"{x, number} {x, plural, one {member}, other {members}}"
}
